// src/utils/orderHelpers.ts

export const getTitleLanguage = (
  map?: Record<string, any>,
  localeCode: string = "en-us",
  isDefault: boolean = true
): string => {
  if (!map) return "";

  if (localeCode && map[localeCode]) {
    return String(map[localeCode]);
  }

  if (!isDefault) return "";

  if (localeCode.toLowerCase().includes("ar")) {
    if (map["ar-sa"]) return String(map["ar-sa"]);
    if (map["ar"]) return String(map["ar"]);
  }

  if (map["en-us"]) return String(map["en-us"]);
  if (map["en"]) return String(map["en"]);

  return "";
};
